import dashboardActiveIcon from "src/assets/images/sidebar/dashboardActiveIcon.svg";
import dashboardIcon from "src/assets/images/sidebar/dashboardIcon.svg";
import kycIcon from "src/assets/images/sidebar/kycIcon.svg";
import kycActiveIcon from "src/assets/images/sidebar/kycActive.svg";
import settingsIcon from "src/assets/images/sidebar/settingsIcon.svg";
import settingsActiveIcon from "src/assets/images/sidebar/settingsActiveIcon.svg";
import usersIcon from "src/assets/images/sidebar/usersIcon.svg";
import usersActiveIcon from "src/assets/images/sidebar/usersActiveIcon.svg";
import adminIcon from "src/assets/images/sidebar/adminIcon.svg";
import adminActiveIcon from "src/assets/images/sidebar/adminActiveIcon.svg";
import bookingsIcon from "src/assets/images/sidebar/bookingsIcon.svg";
import bookingsActiveIcon from "src/assets/images/sidebar/bookingsActiveIcon.svg";
import artisanIcon from "src/assets/images/sidebar/artisanIcon.svg";
import artisanActiveIcon from "src/assets/images/sidebar/artisanActiveIcon.svg";
import walletIcon from "src/assets/images/sidebar/walletIcon.svg";
import walletActiveIcon from "src/assets/images/sidebar/walletActiveIcon.svg";
import disputeIcon from "src/assets/images/sidebar/disputeIcon.svg";
import disputeActiveIcon from "src/assets/images/sidebar/disputeActive.svg";
import adsActiveIcon from "src/assets/images/sidebar/ads2.svg";
import adsInactiveIcon from "src/assets/images/sidebar/ads1.svg";
import feedbackIcon from "src/assets/images/sidebar/feedbackIcon.svg";
import feedbackActiveIcon from "src/assets/images/sidebar/feedbackActiveIcon.svg";
import currencyInactiveIcon from "src/assets/images/sidebar/currencyInactive.svg";
import currencyActiveIcon from "src/assets/images/sidebar/currencyActive.svg";
import requestIcon from "src/assets/images/sidebar/requestIcon.svg";
import React, { useEffect, useState } from "react";
import { useGetAllDisputesQuery } from "src/store/services/disputeApi";

interface Props {
  handleChange: (e: any) => void;
}

interface DisputeTypes {
  id: number;
  description: string;
  booking_id: string;
  createdAt: string;
  display_picture: string;
  status: string;
  name: string;
}

export const DASHBOARD_SIDEBAR_DATA = () => {
  const [disputeData, setDisputeData] = useState<DisputeTypes[]>([
    {} as DisputeTypes,
  ]);

  const [activeCount, setActiveCount] = useState(3);

  // useEffect(() => {
  //   document.title = "Partners Page";
  // }, []);
  

  const [page, setPage] = useState(1);

  const { data: disputesResp, isLoading: isLoadingDisputes } =
    useGetAllDisputesQuery({ page, limit: 10 });
  useEffect(() => {
    const rows: number = disputesResp?.payload?.pagination?.active || [];
    console.log(rows)
    setActiveCount(rows);
    // setDisputeData(rows as any);
  }, [disputesResp]);
  let sidebarData = [
    {
      text: "Dashboard",
      url: "/dashboard",
      icon: dashboardIcon,
      activeIcon: dashboardActiveIcon,
    },
    {
      text: "Verification",
      icon: kycIcon,
      url: "/verification",
      sublinks: [
        {
          text: "Customer",
          url: "/verification/customer",
        },
        {
          text: "Vendor",
          url: "/verification/vendor",
        },
      ],
      activeIcon: kycActiveIcon,
    },
    {
      text: "Customers",
      url: "/customers",
      icon: usersIcon,
      activeIcon: usersActiveIcon,
    },
    {
      text: "Vendors",
      url: "/vendors",
      icon: artisanIcon,
      activeIcon: artisanActiveIcon,
    },
    {
      text: "Partners",
      url: "/partners",
      sublinks: [
        {
          text: "Partners",
          url: "/partners",
        },
        {
          text: "Central Mangers",
          url: "/centralmanger",
        },
        {
          text: "Delivery Partner",
          url: "/add_delivery_partner",
        },
      ],
      icon: artisanIcon,
      activeIcon: artisanActiveIcon,
    },
    {
      text: "Referrals",
      url: "/referrals",
      icon: usersIcon,
      activeIcon: usersActiveIcon,
    },
    {
      text: "Bookings",
      url: "/bookings",
      icon: bookingsIcon,
      activeIcon: bookingsActiveIcon,
    },
    {
      text: "Dispute",
      url: "/dispute",
      count: activeCount,
      icon: disputeIcon,
      activeIcon: disputeActiveIcon,
    },
    {
      text: "Admin",
      url: "/admins",
      icon: adminIcon,
      activeIcon: adminActiveIcon,
    },
    {
      text: "Wallet",
      url: "/wallet",
      icon: walletIcon,
      activeIcon: walletActiveIcon,
    },
    {
      text: "Currency Converter",
      url: "/currency-converter",
      icon: currencyInactiveIcon,
      activeIcon: currencyActiveIcon,
    },
    {
      text: "Ads Management",
      url: "/ads-management",
      icon: adsInactiveIcon,
      activeIcon: adsActiveIcon,
    },
    {
      text: "Withdrawal Requests",
      url: "/withdrawal-requests",
      icon: requestIcon,
      activeIcon: requestIcon,
    },
    // {
    // 	text: 'Request',
    // 	icon: requestIcon,
    // 	url: '/request',
    // 	sublinks: [
    // 		{
    // 			text: 'Customer',
    // 			url: '/request/customer',
    // 		},
    // 		{
    // 			text: 'Vendor',
    // 			url: '/request/vendor',
    // 		},
    // 	],
    // 	activeIcon: requestIcon,
    // },

    {
      text: "Others",
      icon: dashboardIcon,
      url: "/misc",
      sublinks: [
        {
          text: "Banks",
          url: "/misc/banks",
        },
        {
          text: "Occupations",
          url: "/misc/Occupations",
        },
        {
          text: "Categories",
          url: "/misc/categories",
        },
      ],
      activeIcon: dashboardActiveIcon,
    },
    {
      text: "Settings",
      url: "/settings",
      icon: settingsIcon,
      activeIcon: settingsActiveIcon,
    },
    {
      text: "Feedbacks",
      url: "/feedbacks",
      icon: feedbackIcon,
      activeIcon: feedbackActiveIcon,
    },
  ];

  return sidebarData;
};

export default DASHBOARD_SIDEBAR_DATA;
